import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { v4 as SessionID } from 'uuid';

@Injectable({
  providedIn: 'root'
})
export class CustomerContractService {
  public _CustomerContractService = environment.CustomerContract;
  public _httpOptions;
  public sessionId : string
  constructor(private http: HttpClient) { 
    this.sessionId = sessionStorage["SessionId"]
  this._httpOptions = {
    headers: new HttpHeaders({ 'SessionId':this.sessionId })
  };
}


GetPageInitializeDetails(Customername:string): Observable<any>{

  var Query = this._CustomerContractService + '/GetByCustomerName' +'/'+ Customername ;
  return this.http.get<{ data: any }>(Query,this._httpOptions);
}

GetById(customerSiteId:string): Observable<any>{
  var Query = this._CustomerContractService + '/GetById' +'/'+ customerSiteId ;
  return this.http.get<{ data: any }>(Query,this._httpOptions);
}


GetDistance(frombranch:string): Observable<any>{
  var Query = this._CustomerContractService + '/GetDistance' +'/'+ frombranch;
  // console.log(Query);
  return this.http.get<{ data: any }>(Query,this._httpOptions);
}

create(Contract: FormData) {
  var Query = this._CustomerContractService;
  return this.http.post<{ data: any }>(Query, Contract,this._httpOptions);
}

GetById_Search(customerSiteId:string): Observable<any>{
  var Query = this._CustomerContractService + '/GetById_Search' +'/'+ customerSiteId ;
  return this.http.get<{ data: any }>(Query,this._httpOptions);
}


GetDistanceRegion(frombranch:string,toRegionCode:string): Observable<any>{
  var Query = this._CustomerContractService + '/GetDistanceRegion' +'/'+ frombranch +'/'+ toRegionCode;
  // console.log(Query);
  return this.http.get<{ data: any }>(Query,this._httpOptions);
}


GetDistanceFromAndToBranch(frombranch:string, toBranchCode:string): Observable<any>{
  var Query = this._CustomerContractService + '/GetDistanceFromAndToBranch' +'/'+ frombranch +'/'+ toBranchCode;
  // console.log(Query);
  return this.http.get<{ data: any }>(Query,this._httpOptions);
}

}
